import Constants from "src/utils/constants";
import Exception from "src/utils/exception";
import DBOperationsComb from "src/utils/dbOperationsComb";

const tableName = Constants.enums.TABLES_NAME_ENUM.TRIGGER_SETTINGS_TABLE;

async function getTriggerSettings(formId) {
  try {
    const result = await DBOperationsComb.fetchData(
      {
        tableName,
        queryParams: [{ field: "form_id", value: formId }],
        fetchAll: true
      },
      true
    );
    if (!result?.data?.length) {
      return { data: null, error: "No matching trigger settings found." };
    }
    result.data.forEach((setting) => {
      setting.action_data = setting.action_data || {};
    });
    return { data: result.data, error: null };
  } catch (error) {
    Exception.catchException(error);
    return { error };
  }
}

async function getAllTriggerSettings(config = {}) {
  try {
    const result = await DBOperationsComb.fetchData(
      {
        tableName,
        ...config
      },
      true
    );

    if (!result?.data) {
      return { data: [], total: 0, error: "Failed to fetch trigger settings." };
    }

    result.data.forEach((setting) => {
      setting.action_data = setting.action_data || {};
    });

    return {
      data: result.data,
      total: result.totalItems,
      error: null
    };
  } catch (error) {
    Exception.catchException(error);
    return { error, total: 0 };
  }
}

async function updateTriggerSetting(data) {
  try {
    const result = await DBOperationsComb.updateData(tableName, data, true);
    return result.error ? { error: result.error } : { data };
  } catch (error) {
    Exception.catchException(error);
    return { error };
  }
}

async function createTriggerSetting(data) {
  try {
    data.created_at = new Date().toISOString();
    data.is_deleted = false;

    const result = await DBOperationsComb.insertData(tableName, data, true);
    return result.error ? { error: result.error } : { data };
  } catch (error) {
    Exception.catchException(error);
    return { error };
  }
}

async function deleteTriggerSetting(id) {
  try {
    const data = {
      id,
      is_deleted: true
    };

    const result = await DBOperationsComb.updateData(tableName, data, true);

    return result.error
      ? { error: result.error }
      : { success: true, message: "Trigger setting deleted successfully" };
  } catch (error) {
    Exception.catchException(error);
    return { error: error.message || "Failed to delete trigger setting" };
  }
}

export default {
  getTriggerSettings,
  getAllTriggerSettings,
  updateTriggerSetting,
  createTriggerSetting,
  deleteTriggerSetting
};
